import mapboxgl from 'mapbox-gl'
import carto from '@carto/carto-vl'
// import * as airship from '@carto/airship-bridge'
import axios from 'axios'
import config from '../config'

function updateCartoData (layer, store, variableName) {
  if (layer.viz && layer.viz.variables) {
    const featureNb = layer.viz.variables.viewportCount.value
    store.commit('setFeatureNb', featureNb)
  }
}

export const init = (store) => {
  mapboxgl.accessToken = 'pk.eyJ1IjoidG9tcmFnIiwiYSI6ImQ4OWZiMWQwOGM5NDNmMGIzNDhlM2I0MGI5NGM4MzFhIn0.-7KNnHCqDmjUJ-tvjngx-A'
  global.map = new mapboxgl.Map({
    container: 'map',
    style: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
    zoom: 8.37,
    center: [-79.59, 43.875],
    hash: true
  })

  const popup = new mapboxgl.Popup({
    closeButton: true,
    closeOnClick: false
  })

  let place = 'Scotiabank Arena'

  const source = new carto.source.SQL(`
      SELECT t1.cartodb_id, t1.location_name, t1.cfsaidu, sum(t1.visitors) visitors, t1.the_geom, t1.the_geom_webmercator  
      FROM acc_daily_visitors_2 t1
      WHERE t1.location_name = '${place}'
        AND (t1.datetime >=  (SELECT min(datetime) FROM acc_daily_visitors_2) AND datetime < (SELECT max(datetime) FROM acc_daily_visitors_2))
      GROUP BY t1.cartodb_id, t1.location_name, t1.cfsaidu, t1.the_geom, t1.the_geom_webmercator
  `, {
    apiKey: '97212563298641dbf0fd6a32d2cc9504e3fe468a',
    username: 'anagraph-clement'
  })

  var viz = new carto.Viz(`
    color: opacity(ramp(globalQuantiles($visitors,6),[#441853,#45367F,#37648E,#289E87,#66BE64,#F7E822]),0.86)
    @cfsaidu: $cfsaidu
    @visitors: $visitors
    @location_name: $location_name
    @viewportCount: viewportSum($visitors)
  `)

  const layer = new carto.Layer('telus', source, viz)
  layer.addTo(global.map, 'road_minor_case')

  layer.on('loaded', () => {
    loadDemographicStatsLayer()
    const poiViz = new carto.Viz(`
    width: 50
    symbol: image('https://i.ibb.co/7W97sby/clipart-2-10-17-20-33.png')
    filter:  $name == 'Scotiabank Arena'
    `)
    const poiSource = new carto.source.SQL(`select * from toronto_poi`, {
      apiKey: '97212563298641dbf0fd6a32d2cc9504e3fe468a',
      username: 'anagraph-clement'
    })
    const poiLayer = new carto.Layer('poi', poiSource, poiViz)

    poiLayer.addTo(global.map)

    getLabelData()
    getLegendData(layer)
    console.log('loaded')
    document.querySelector('.loaded').style.opacity = '0'
    document.querySelector('.loaded').style.zIndex = '-1'
  })

  layer.on('updated', () => {
    getLegendData(layer)
  })

  const interactivity = new carto.Interactivity(layer)
  interactivity.on('featureClick', event => {
    const feature = event.features[0]
    feature.color.blendTo('opacity(White, 0.5)')
    feature.strokeWidth.blendTo('2')
    feature.strokeColor.blendTo('opacity(#2a2a36, 0.8)')
    const coords = event.coordinates
    const locationName = feature.variables.location_name.value
    const fsa = feature.variables.cfsaidu.value
    const count = feature.variables.visitors.value
    const html = `
          <h3 class="as-title"> From ${fsa} </h3>
          <p> <b> To : ${locationName}</p>
          <p>Total : ${count}</p>
          `
    popup.setLngLat([coords.lng, coords.lat])
    popup.setHTML(html)
    popup.addTo(global.map)
  })
  interactivity.on('featureLeave', event => {
    const feature = event.features[0]
    feature.color.reset()
    feature.strokeWidth.reset()
    feature.strokeColor.reset()
  })

  global.map.on('load', () => {
    global.map.on('idle', () => {
      updateCartoData(layer, store)
    })
    global.map.on('moveend', () => {
      updateCartoData(layer, store)
    })
  })

  const getLabelData = () => {
    let SQL_CLIENT = axios.create({
      method: 'get',
      url: `https://anagraph-clement.carto.com/api/v2/sql?`,
      params: {
        api_key: 'default_public'
      }
    })
    let query = `select rtaidu, st_x(st_transform(ST_Centroid(the_geom),4326)) as lat, 
    st_y(st_transform(ST_Centroid(the_geom),4326)) as lng, cartodb_id from demo2016_rta `
    SQL_CLIENT.request({
      params: {
        q: query
      }
    })
      .then((response) => {
        if (response && response.data) {
          addStyledLabelToMap(response.data.rows, 'cookitDllBy', 'rtaidu')
        }
      })
  }
  const addStyledLabelToMap = (data, layerId, labelField) => {
    let map = global.map
    if (map.getSource(`labels_4_${layerId}`)) {
      map.removeLayer(`labels_4_${layerId}`)
      map.removeSource(`labels_4_${layerId}`)
    }
    map.addSource(`labels_4_${layerId}`, { type: 'geojson', data: null })
    const labelSource = map.getSource(`labels_4_${layerId}`)
    const geojsonFeatures = data.map(feature => {
      return {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [feature.lat, feature.lng]
        },
        'properties': {
          'label_field': `${feature[labelField]}`
        }
      }
    })
    // Set the new data in the source layer
    labelSource.setData({
      type: 'FeatureCollection',
      features: geojsonFeatures
    })
    map.addLayer({
      'id': `labels_4_${layerId}`,
      'type': 'symbol',
      'source': `labels_4_${layerId}`,
      'layout': {
        'text-field': '{label_field}',
        'text-size': {
          'stops': [
            [9, 6],
            [11, 12],
            [16, 16],
            [18, 24]
          ]
        },
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-letter-spacing': 0.1,
        'text-max-width': 9,
        'text-transform': 'uppercase'
      },
      'paint': {
        'text-color': '#fff',
        'text-halo-color': '#333',
        'text-halo-width': 1,
        'text-halo-blur': 0.25
      }
    })
  }
  const getLegendData = (layer) => {
    const legendData = layer.viz.color.getLegendData()
    const legend = document.querySelector('#legend')
    let legendItems = []
    legendData.data.map(item => {
      legendItems.push({
        'color': `rgba(${item.value.r},${item.value.g},${item.value.b},1)`,
        'label': item.key[1] })
    })
    legend.data = legendItems
  }
  const loadDemographicStatsLayer = () => {
    const source = new carto.source.SQL(`SELECT cartodb_id,the_geom_webmercator,r1,r51,r742,r2248,r759,r2249,r2250,r2251,r2252,r2253,r8,r2254,r2255,r2256,r2257,null 
    FROM demo2016_ad_centroids WHERE r1 <> 0`, {
      apiKey: '97212563298641dbf0fd6a32d2cc9504e3fe468a',
      username: 'anagraph-clement'
    })
    const viz = new carto.Viz(`
      @population: viewportSum(clusterAvg($r1))
      @houseCount: viewportSum(clusterAvg($r51))
      @incomeAvg: viewportAvg(clusterAvg($r742))
      @revenu_r2248: viewportAvg(clusterSum($r2248) / clusterSum($r759)* 100)
      @revenu_r2249: viewportAvg(clusterSum($r2249) / clusterSum($r759)* 100)
      @revenu_r2250: viewportAvg(clusterSum($r2250) / clusterSum($r759)* 100)
      @revenu_r2251: viewportAvg(clusterSum($r2251) / clusterSum($r759)* 100)
      @revenu_r2252: viewportAvg(clusterSum($r2252) / clusterSum($r759)* 100)
      @age_r2253: viewportAvg(clusterSum($r2253) / clusterSum($r8)* 100)
      @age_r2254: viewportAvg(clusterSum($r2254) / clusterSum($r8)* 100)
      @age_r2255: viewportAvg(clusterSum($r2255) / clusterSum($r8)* 100)
      @age_r2256: viewportAvg(clusterSum($r2256) / clusterSum($r8)* 100)
      @age_r2257: viewportAvg(clusterSum($r2257) / clusterSum($r8)* 100)
      resolution : 64     
      color: opacity(white, 0) 
      strokeColor: opacity(black, 0)
      `)
    const layer = new carto.Layer('statistics', source, viz)
    layer.addTo(global.map)
    layer.on('updated', () => updateStatistics('statistics'))
  }
  const getCartoLayerVariable = (type, variable) => {
    const layer = global.map.getLayer('statistics')
    try {
      return layer.implementation.viz.variables[variable].eval()
    } catch (error) {
      console.log(error)
      return null
    }
  }
  const updateStatistics = (type) => {
    const variables = config.statisticsVariables.filter((types) => {
      return types.type === type
    }).map(({ id }) => {
      return { id, value: getCartoLayerVariable(type, id) }
    })
    store.commit('setStatistics', variables)
  }
}
